export default __webpack_public_path__ + "static/media/lungs_img_0007_Vaping.8d57c364.png";